<template>
  <CModal :visible="showModal"  size="lg" @close="showModal=false" backdrop="static">
    <CModalHeader>
      <CModalTitle v-html="$t('company.applyForDeactivationCompany', {name:company.name})" />
    </CModalHeader>
    <CModalBody class="">
      <div class="mb-3">
      <input-field
        name="payload.title"
        :label="$t('actions.subject')"
        :errors="errors"
        required
        v-model="action.title"
      />
      </div>
      <div class="mb-3">
        <text-area-field
          name="payload.description"
          v-model="action.description"
          :label="$t('actions.description')"
          minHeight="10vh"
          :errors="errors" />
      </div>
    </CModalBody>
    <CModalFooter>
      <div class="col text-end">
        <button class="btn btn-outline-dark me-3" @click="showModal=false">{{ $t('common.btnCancel') }}</button>
        <button class="btn btn-danger" @click="request()">{{ $t('actions.submitRequest') }}</button>
      </div>
    </CModalFooter>
  </CModal>
</template>

<script>
import {CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle} from "@coreui/bootstrap-vue";
import {isDisabled} from "bootstrap/js/src/util";
import SelectField from "@/components/selectField.vue";
import InputField from "@/components/inputField.vue";
import TextAreaField from "@/components/textAreaField.vue";
import WidgetAction from "@/pages/crm/widgetAction.vue";
import EventBus from "@/eventBus";

export default {
  name: "modalDeletingRequest",
  components: {
    WidgetAction,
    TextAreaField,
    InputField,
    SelectField,
    CModal, CModalBody,
    CModalFooter,
    CModalHeader,
    CModalTitle,
  },
  emits: ['update'],
  props: {
    shown: Boolean,
    company: {
      type: Object,
      required: true,
    }
  },
  watch: {
    shown(value) {
      if(value === false) {
        this.reset();
      }
      else{
        this.$root.setModalHidden(false);
      }
      this.showModal = value;
    },
    showModal(value) {
      this.$emit('update:shown', value);
    },
  },
  data() {
    return {
      showModal: false,
      errors: {},
      action:{
        title: '',
        description: '',
      }
    };
  },
  mounted() {
    this.showModal = this.shown;
  },
  methods:{
    reset(){
      this.errors = {};
    },
    request(){
      let url = 'crm/companies/' + this.company.id + "/doAction";
      this.errors = {};

      this.axios.post(url, {action: 'deletingRequest', payload: this.action}).then(res => {
          EventBus.$emit('company.update', {company_id: this.company.id});
          this.showModal = false;
      }).catch(error => {
        if (error.response.status === 422) {
          this.errors = error.response.data.errors || {};
          this.$toast.error(this.$t('common.inputError'));
        }
        else{
          this.$toast.error(this.$t('common.error'));
        }
      });
    }
  }
}
</script>

<style scoped>

</style>